(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire61da"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire61da"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4GJKx", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $369e92947825c2b5$export$71511d61b312f219; });
function $369e92947825c2b5$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("1wc17", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $11b219ef186b1c94$export$71511d61b312f219; });
function $11b219ef186b1c94$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $11b219ef186b1c94$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $11b219ef186b1c94$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $11b219ef186b1c94$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("cv9Rk", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $91a007218046315e$export$71511d61b312f219; });

var $hrk7H = parcelRequire("hrk7H");

var $fBJYg = parcelRequire("fBJYg");

var $e8oCh = parcelRequire("e8oCh");

var $1hjNY = parcelRequire("1hjNY");
function $91a007218046315e$export$71511d61b312f219(arr, i) {
    return (0, $hrk7H._)(arr) || (0, $fBJYg._)(arr, i) || (0, $1hjNY._)(arr, i) || (0, $e8oCh._)();
}

});
parcelRegister("hrk7H", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cb24915816a1cfc9$export$71511d61b312f219; });
function $cb24915816a1cfc9$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("fBJYg", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b5cdf895c6f08ea2$export$71511d61b312f219; });
function $b5cdf895c6f08ea2$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("e8oCh", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a4a4e8541bb818da$export$71511d61b312f219; });
function $a4a4e8541bb818da$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("1hjNY", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0ee6bdd820e270f4$export$71511d61b312f219; });

var $QCMVH = parcelRequire("QCMVH");
function $0ee6bdd820e270f4$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $QCMVH._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $QCMVH._)(o, minLen);
}

});
parcelRegister("QCMVH", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $09e2f1f84ceddf09$export$71511d61b312f219; });
function $09e2f1f84ceddf09$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("bDtS0", function(module, exports) {

module.exports = (parcelRequire("eg86f"))($parcel$resolve("gtIz8")).then(function() {
    return parcelRequire('efzFk');
});

});
parcelRegister("eg86f", function(module, exports) {
"use strict";

var $31a2I = parcelRequire("31a2I");
module.exports = $31a2I(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("31a2I", function(module, exports) {
"use strict";
var $23294162c634ba05$var$cachedBundles = {};
var $23294162c634ba05$var$cachedPreloads = {};
var $23294162c634ba05$var$cachedPrefetches = {};
function $23294162c634ba05$var$getCache(type) {
    switch(type){
        case 'preload':
            return $23294162c634ba05$var$cachedPreloads;
        case 'prefetch':
            return $23294162c634ba05$var$cachedPrefetches;
        default:
            return $23294162c634ba05$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $23294162c634ba05$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("90uLt", function(module, exports) {

module.exports = (parcelRequire("eg86f"))($parcel$resolve("hqUQE")).then(function() {
    return parcelRequire('afgfh');
});

});

parcelRegister("1IVwU", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("9eRl8"))($parcel$resolve("jba44")),
    (parcelRequire("eg86f"))($parcel$resolve("jHiBg"))
]).then(function() {
    return parcelRequire('2jXMD');
});

});
parcelRegister("9eRl8", function(module, exports) {
"use strict";

var $31a2I = parcelRequire("31a2I");
module.exports = $31a2I(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});


var $633ca7d257eae762$exports = {};
$parcel$extendImportMap({
    "gtIz8": "configurator.43dce625.js",
    "hqUQE": "resellers.68f68a48.js",
    "jHiBg": "slider.31b16058.js",
    "jba44": "slider.3aae86e5.css"
});

//import '../assets/css/styles.css';
// menu-trigger on click add menu-layer active class
var $bed8d47175edd3bc$var$menuTrigger = document.querySelector('.menu-trigger');
if ($bed8d47175edd3bc$var$menuTrigger) {
    $bed8d47175edd3bc$var$menuTrigger.addEventListener('click', function() {
        document.querySelector('.menu-layer').classList.add('active');
    });
    document.querySelector('.menu-trigger-close').addEventListener('click', function() {
        document.querySelector('.menu-layer').classList.remove('active');
    });
}
var $bed8d47175edd3bc$var$menuLayerImgLinks = document.querySelectorAll('.menu-layer a[data-img]');
if ($bed8d47175edd3bc$var$menuLayerImgLinks) $bed8d47175edd3bc$var$menuLayerImgLinks.forEach(function(link) {
    link.addEventListener('mouseover', function() {
        var imgSrc = this.getAttribute('data-img');
        document.querySelector('.menu-layer-img img').setAttribute('src', imgSrc);
    });
});
// add scroll class to site-header on scroll
/*window.addEventListener('scroll', function() {
    const header = document.querySelector('.site-header');
    if (window.scrollY > 200) {
        header.classList.add('scroll');
    } else {
        header.classList.remove('scroll');
    }

    let scrollDirection = window.scrollY > this.lastScroll ? 'down' : 'up';
    if (scrollDirection === 'down' && window.scrollY > 200) {
        header.style.transform = 'translateY(-100%)';
    } else {
        header.style.transform = 'translateY(0)';
    }
    this.lastScroll = window.scrollY;

});*/ function $bed8d47175edd3bc$var$setResponsiveVideo() {
    var videos = document.querySelectorAll('video');
    if (videos) videos.forEach(function(video) {
        if (window.innerWidth < 800) video.setAttribute('src', video.dataset.src_mobile);
        else video.setAttribute('src', video.dataset.src);
    });
}
$bed8d47175edd3bc$var$setResponsiveVideo();
// close other details when one is opened
var $bed8d47175edd3bc$var$detailsElements = document.querySelectorAll('details');
if ($bed8d47175edd3bc$var$detailsElements) $bed8d47175edd3bc$var$detailsElements.forEach(function(details) {
    details.addEventListener('toggle', function() {
        var _this = this;
        if (this.open) $bed8d47175edd3bc$var$detailsElements.forEach(function(otherDetails) {
            if (otherDetails !== _this) otherDetails.removeAttribute('open');
        });
    });
});
/* steam effect js */ var $bed8d47175edd3bc$var$steamBtn = document.getElementById('steam-btn');
if ($bed8d47175edd3bc$var$steamBtn) $bed8d47175edd3bc$var$steamBtn.addEventListener('click', function() {
    var _loop = function(i) {
        var steam = document.createElement('div');
        steam.className = 'steam';
        steam.style.left = 30 + Math.random() * 40 + '%';
        steam.style.width = 120 + Math.random() * 120 + 'px';
        steam.style.height = 180 + Math.random() * 120 + 'px';
        steam.style.animationDelay = Math.random() * 0.3 + 's';
        container.appendChild(steam);
        setTimeout(function() {
            steam.remove();
        }, 2200); // Slightly longer to match possible delay
    };
    var container = document.getElementById('steam-container');
    var bubbleCount = 8;
    for(var i = 0; i < bubbleCount; i++)_loop(i);
});



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $cv9Rk = parcelRequire("cv9Rk");
var $7cf7512a7c16555e$var$Filters = /*#__PURE__*/ function() {
    "use strict";
    function Filters() {
        (0, $4GJKx._)(this, Filters);
        this.activeFilters = {};
        this.init();
    }
    (0, $1wc17._)(Filters, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                var toggleFiltersButton = document.querySelector('.toggle-filters');
                var filterModal = document.querySelector('.products-filter');
                var closeFiltersButton = document.querySelector('.products-filter .close');
                closeFiltersButton.addEventListener('click', function(event) {
                    filterModal.classList.remove('active');
                });
                toggleFiltersButton.addEventListener('click', function(event) {
                    event.preventDefault();
                    filterModal.classList.toggle('active');
                });
                var filterElements = document.querySelectorAll('.filter');
                filterElements.forEach(function(filter) {
                    filter.addEventListener('click', function(event) {
                        event.preventDefault();
                        // add active class to the clicked filter a element and remove it from others same category
                        var filterCategory = event.target.parentElement.dataset.filter;
                        var filterLinks = document.querySelectorAll('.filter[data-filter="'.concat(filterCategory, '"] a'));
                        filterLinks.forEach(function(link) {
                            link.classList.remove('active');
                        });
                        event.target.classList.add('active');
                        _this.activeFilters[filterCategory] = event.target.dataset[filterCategory];
                        _this.applyFilters();
                    });
                });
            }
        },
        {
            key: "applyFilters",
            value: function applyFilters() {
                var _this = this;
                var products = document.querySelectorAll('.serie');
                products.forEach(function(product) {
                    var show = true;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.entries(_this.activeFilters)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = (0, $cv9Rk._)(_step.value, 2), category = _step_value[0], value = _step_value[1];
                            if (product.dataset[category] !== value) {
                                show = false;
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    product.style.display = show ? '' : 'none';
                });
            }
        }
    ]);
    return Filters;
}();
document.addEventListener('DOMContentLoaded', function() {
    if (document.querySelector('.toggle-filters')) new $7cf7512a7c16555e$var$Filters();
});


/*document.querySelectorAll('.tabs').forEach(tabsInstance => {
    const tabLinks = tabsInstance.querySelectorAll('.tablinks a');
    console.log(tabLinks);
    const tabPanels = tabsInstance.querySelectorAll('.panel');
    tabLinks.forEach(link => {
        link.addEventListener('click', function(event) {
            event.preventDefault();
            const targetPanelId = this.getAttribute('href').substring(1);
            const targetPanel = tabsInstance.querySelector('#' + targetPanelId);
            if (targetPanel) {
                // Hide all panels in this instance
                tabPanels.forEach(panel => {
                    panel.style.display = 'none';
                });
                // Remove active class from all links in this instance
                tabLinks.forEach(link => {
                    link.classList.remove('active');
                });
                // Show the target panel and set the link as active
                targetPanel.style.display = 'block';
                this.classList.add('active');
            } else {
                console.error(`Panel with ID ${targetPanelId} not found in this tabs instance.`);
            }
        });
    });
});

*/ var $72a2271b526d981a$var$tabLinks = document.querySelectorAll('.tablinks a');
var $72a2271b526d981a$var$tabPanels = document.querySelectorAll('.tabs .panel');
$72a2271b526d981a$var$tabLinks.forEach(function(link) {
    link.addEventListener('click', function(event) {
        event.preventDefault();
        var siblingLinks = Array.from(this.closest('.tablinks').querySelectorAll('a'));
        var targetPanelId = this.getAttribute('href').substring(1);
        var targetPanel = document.getElementById(targetPanelId);
        if (targetPanel) {
            // Hide all panels
            $72a2271b526d981a$var$tabPanels.forEach(function(panel) {
                // if in sibling panels, hide, otherwise leave as is
                if (siblingLinks.some(function(siblingLink) {
                    return siblingLink.getAttribute('href').substring(1) === panel.id;
                })) panel.style.display = 'none';
            });
            // Remove active class from all links
            $72a2271b526d981a$var$tabLinks.forEach(function(link) {
                if (siblingLinks.includes(link)) link.classList.remove('active');
            });
            // Show the target panel and set the link as active
            targetPanel.style.display = 'block';
            this.classList.add('active');
        } else console.error("Panel with ID ".concat(targetPanelId, " not found."));
    });
});


function $4429e176f43538de$var$animateValue(obj) {
    var end = parseInt(obj.dataset.end);
    var current = 0;
    var increment = parseInt(obj.dataset.end / 8);
    var stepTime = 80;
    var objNr = obj.querySelector('span');
    var timer = setInterval(function() {
        current += increment;
        objNr.innerHTML = current.toString();
        if (current > end) {
            objNr.innerHTML = end.toLocaleString('et-EE');
            clearInterval(timer);
        }
    }, stepTime);
}
var $4429e176f43538de$var$scrollingNumbers = [].slice.call(document.querySelectorAll(".countable"));
var $4429e176f43538de$var$numbersObserver = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
        if (entry.isIntersecting) {
            $4429e176f43538de$var$animateValue(entry.target);
            entry.target.parentElement.classList.add('counted');
            $4429e176f43538de$var$numbersObserver.unobserve(entry.target);
        }
    });
});
$4429e176f43538de$var$scrollingNumbers.forEach(function(element) {
    $4429e176f43538de$var$numbersObserver.observe(element);
});


document.addEventListener("DOMContentLoaded", function() {
    function loadThermometer() {
        var thermometerElementC = document.getElementById("thermometer-c");
        var thermometerElementF = document.getElementById("thermometer-f");
        var animation = lottie.loadAnimation({
            container: thermometerElementC,
            renderer: "svg",
            loop: false,
            autoplay: false,
            path: thermometerElementC.dataset.src
        });
        var animation2 = lottie.loadAnimation({
            container: thermometerElementF,
            renderer: "svg",
            loop: false,
            autoplay: false,
            path: thermometerElementF.dataset.src
        });
        animation.addEventListener('DOMLoaded', function() {
            var currentStep = 0;
            var totalFrames = animation.getDuration(true);
            var frameRate = animation.frameRate;
            //const duration = animation.getDuration(true) /  animation.frameRate; // duration in seconds
            var exploreElement = document.querySelector('.explore');
            document.getElementById('toggleTemp').addEventListener('click', function() {
                exploreElement.classList.add('hidden');
                var currentFrame = currentStep * frameRate;
                currentStep++;
                var targetFrame = currentStep * frameRate;
                if (targetFrame > totalFrames) {
                    targetFrame = frameRate;
                    currentStep = 1;
                    currentFrame = 0;
                }
                animation.playSegments([
                    currentFrame,
                    targetFrame
                ], true);
                animation2.playSegments([
                    currentFrame,
                    targetFrame
                ], true);
                showThermometerTabs(currentStep);
            });
            document.getElementById('unit-switch').addEventListener('change', function() {
                var isChecked = this.querySelector('input').checked;
                var currentUnit = isChecked ? 'C' : 'F';
                thermometerElementC.classList.toggle('hidden');
                thermometerElementF.classList.toggle('hidden');
                document.querySelectorAll('.step').forEach(function(step) {
                    var showCelsius = currentUnit === 'C';
                    step.querySelector('.fahrenheit').classList.toggle('hidden', showCelsius);
                    step.querySelector('.celcius').classList.toggle('hidden', !showCelsius);
                });
            });
        });
    }
    function showThermometerTabs(currentStep) {
        var steps = document.querySelectorAll('.step');
        steps.forEach(function(step) {
            if (parseInt(step.dataset.id) === currentStep) step.classList.remove('hidden');
            else step.classList.add('hidden');
        });
        var progress = document.querySelector('.steps');
        var total = steps.length;
        if (currentStep === total) steps[0].classList.remove('hidden');
        var percent = currentStep / (total - 1) * 100;
        if (currentStep === steps.length) percent = 0;
        progress.style.setProperty('--percent', percent + '%');
    }
    if (document.getElementById("thermometer-c")) loadThermometer();
});


var $61428dc1a1443e1a$var$configurator = document.querySelector('.configurator');

if ($61428dc1a1443e1a$var$configurator) (parcelRequire("bDtS0")).then(function(Configurator) {
    Configurator.default.init();
}).catch(function(err) {
    console.error('Failed to load Configurator module:', err);
});
var $61428dc1a1443e1a$var$resellersMapElement = document.getElementById('mapContainer');

if ($61428dc1a1443e1a$var$resellersMapElement) (parcelRequire("90uLt")).then(function(Resellers) {
    Resellers.default.init($61428dc1a1443e1a$var$resellersMapElement);
}).catch(function(err) {
    console.error('Failed to load Resellers module:', err);
});
var $61428dc1a1443e1a$var$sectionSliders = document.querySelectorAll('.section-slider');

if ($61428dc1a1443e1a$var$sectionSliders.length > 0) (parcelRequire("1IVwU")).then(function(Slider) {
    new Slider.default();
}).catch(function(err) {
    console.error('Failed to load Slider module:', err);
});
// menu link data attribute
document.querySelectorAll('ul.hover-scroll li > a').forEach(function(link) {
    if (!link.parentElement.getAttribute('data-text')) link.parentElement.setAttribute('data-text', link.textContent.trim());
});
// Custom cursor
options = {
    "outerStyle": "disable",
    "hoverEffect": "pointer-blur",
    "hoverItemMove": false,
    "defaultCursor": false,
    "outerWidth": 20,
    "outerHeight": 20
};
magicMouse(options);
var $61428dc1a1443e1a$var$cursorPointer = document.getElementById('magicPointer');
if (document.querySelector('.section-slider')) {
    document.querySelector('.section-slider .swiper').addEventListener('mouseover', function() {
        $61428dc1a1443e1a$var$cursorPointer.classList.add('pointer-slide');
    });
    document.querySelector('.section-slider .swiper').addEventListener('mouseout', function() {
        $61428dc1a1443e1a$var$cursorPointer.classList.remove('pointer-slide');
    });
}
var $61428dc1a1443e1a$var$imgLinks = document.querySelectorAll('.img-link-col');
$61428dc1a1443e1a$var$imgLinks.forEach(function(link) {
    link.addEventListener('mouseover', function() {
        $61428dc1a1443e1a$var$cursorPointer.classList.add('pointer-arrow');
    });
    link.addEventListener('mouseout', function() {
        $61428dc1a1443e1a$var$cursorPointer.classList.remove('pointer-arrow');
    });
}); /* Leaflet map */  /*
const mapElement = document.getElementById('map');
if (mapElement) {
    import('./js/./Leafletmap').then(Map => {
        Map.Leafletmap.init(mapElement);
    }).catch(err => {
        console.error('Failed to load Map module:', err);
    });
}*/  /* testing */  /*const container = document.getElementById('zoomable');
const parent = container.parentElement;
if (container && parent) {
    let scale = 1, lastX = 0, lastY = 0, posX = 0, posY = 0, dragging = false;

    function clamp(val, min, max) {
        return Math.max(min, Math.min(max, val));
    }

    function getBounds() {
        const parentRect = parent.getBoundingClientRect();
        const width = container.offsetWidth * scale;
        const height = container.offsetHeight * scale;
        const minX = Math.min(0, parentRect.width - width);
        const maxX = 0;
        const minY = Math.min(0, parentRect.height - height);
        const maxY = 0;
        // If content is smaller, center it
        return {
            minX: width > parentRect.width ? minX : (parentRect.width - width) / 2,
            maxX: width > parentRect.width ? maxX : (parentRect.width - width) / 2,
            minY: height > parentRect.height ? minY : (parentRect.height - height) / 2,
            maxY: height > parentRect.height ? maxY : (parentRect.height - height) / 2
        };
    }

    function updateTransform() {
        const { minX, maxX, minY, maxY } = getBounds();
        posX = clamp(posX, minX, maxX);
        posY = clamp(posY, minY, maxY);
        container.style.transform = `translate(${posX}px, ${posY}px) scale(${scale})`;
    }

    container.addEventListener('mousedown', e => {
        dragging = true;
        lastX = e.clientX;
        lastY = e.clientY;
    });

    window.addEventListener('mousemove', e => {
        if (!dragging) return;
        posX += e.clientX - lastX;
        posY += e.clientY - lastY;
        lastX = e.clientX;
        lastY = e.clientY;
        updateTransform();
    });

    window.addEventListener('mouseup', () => dragging = false);

    container.addEventListener('wheel', e => {
        e.preventDefault();
        const delta = e.deltaY > 0 ? -0.1 : 0.1;
        const newScale = clamp(scale + delta, 1, 3);
        if (newScale !== scale) {
            const rect = container.getBoundingClientRect();
            const parentRect = parent.getBoundingClientRect();
            const mouseX = e.clientX - parentRect.left - rect.width / 2 - posX;
            const mouseY = e.clientY - parentRect.top - rect.height / 2 - posY;
            posX -= mouseX * (newScale - scale) / scale;
            posY -= mouseY * (newScale - scale) / scale;
            scale = newScale;
            updateTransform();
        }
    }, { passive: false });

    updateTransform();
}
*/ 

})();
//# sourceMappingURL=index.js.map
